import React from 'react';
import './index.css'
import { useMediaQuery } from '../../hooks/MediaQuery.hook';
import { DEFAULT_LEAGUE_LINK } from '../../utils/constant';

export default function MainDescription() {
    const matches = useMediaQuery('(min-width: 768px)');

    return (
        <div className='home-details no-web-display' style={matches ? { padding: '20px' }:{}}>            
            <h2 className='collection'>Why Choose SportsFeed24 for Live Sports Streaming?</h2>
            <p className='card-description'>
               Sportsfeed24 is a free live sports streaming platform trusted by millions of fans across Pakistan
                and worldwide. Watch soccer, football, cricket, NFL, NBA, UFC, boxing, F1, tennis, and rugby in
                HD — no subscription, no registration, and no hidden fees.
            </p>

            <p className='card-description'>
                Our streams are fast, stable, and optimized for every device — phone, tablet, laptop, or smart TV.
                Whether you follow the Premier League, PSL, Champions League, NFL, or UFC, you will find a clear
                schedule of today&apos;s matches and the full week ahead onsportsfeed24.
            </p>

            <table className='card-description' style={{width: '100%', marginBottom: '20px'}}>
                <thead>
                    <tr>
                        <th style={{textAlign: 'left'}}>Feature</th>
                        <th style={{textAlign: 'left'}}>Benefit</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>100% Free Access</td>
                        <td>No subscriptions or hidden fees for any sports stream</td>
                    </tr>
                    <tr>
                        <td>Multi-Device Support</td>
                        <td>Watch on phones, tablets, PCs, and smart TVs</td>
                    </tr>
                    <tr>
                        <td>Minimal Buffering</td>
                        <td>Optimized servers for smooth HD streaming</td>
                    </tr>
                    <tr>
                        <td>Comprehensive Coverage</td>
                        <td>5,000+ monthly live streams across all major leagues</td>
                    </tr>
                </tbody>
            </table>

            <h2 className='collection'>Top Soccer &amp; Football Leagues Available Live</h2>
            <p className='card-description'>
                SportsFeed24 offers access to the world&apos;s most popular <strong>soccer streams</strong> and
                <strong> football streams</strong>, covering every major tournament with multiple player options:
            </p>
            
            <div>
                <ul>
                    <li>
                        <p>
                            <span className='collection'>Premier League Streams</span>
                        </p>
                        <p className='card-description'>
                            Watch all 380 Premier League matches each season — Manchester United, Liverpool, Arsenal,
                            derby days, title deciders, and relegation battles — with free HD soccer streams.
                        </p>
                        <p className='card-description'>
                            Check our updated <a href='/leagues/standings'>Premier League standings</a> and visit our{' '}
                            <a href={DEFAULT_LEAGUE_LINK}>Premier League fixtures</a> page for match schedules.
                        </p>
                    </li>

                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'>Champions League Football Streams</span>
                        </p>
                        <p className='card-description'>
                            Never miss a UEFA Champions League night. We cover all group stage matches, knockout
                            rounds, quarter-finals, and the grand final with multiple streaming options.
                        </p>
                    </li>

                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'>International Soccer Streams</span>
                        </p>
                        <p className='card-description'>
                            From FIFA World Cup qualifiers to EURO and Copa América, SportsFeed24 delivers all
                            major international <strong>soccer streams</strong> in one place.
                        </p>
                    </li>
                </ul>
            </div>

            <h2 className='collection'>How to Watch Live Sports on SportsFeed24</h2>
            <p className='card-description'>
                Getting started with <strong>free sports streaming</strong> onsportsfeed24 takes seconds:
            </p>
            <ol className='card-description'>
                <li>Visit the homepage for today&apos;s live matches</li>
                <li>Select your sport or match</li>
                <li>Choose from multiple player options</li>
                <li>Enjoy the match in HD quality</li>
            </ol>

            <h2 className='collection'>Sports Streaming FAQ</h2>
            <div className='card-description'>
                <p><strong>Q: Is SportsFeed24 free to use?</strong></p>
                <p>A: Yes. All streams onsportsfeed24 are completely free with no registration required.</p>
                
                <p><strong>Q: What devices are supported?</strong></p>
                <p>A: SportsFeed24 works on iOS, Android, Windows, Mac, and smart TVs.</p>
                
                <p><strong>Q: Which sports can I watch?</strong></p>
                <p>A: Soccer, football, cricket, NFL, NBA, UFC, boxing, F1, tennis, rugby, MotoGP, NHL, MLB, and MLS.</p>
            </div>

            <h2 className='collection'>Beyond Soccer: Full Sports Coverage</h2>
            <p className='card-description'>
                While soccer is our top priority,Sportsfeed24 also offers:
            </p>
            <ul className='card-description'>
                <li><a href='/streams/nfl'>NFL Streams</a> – Every Sunday game plus playoffs and the Super Bowl</li>
                <li><a href='/streams/nba'>NBA Streams</a> – Regular season and playoff coverage</li>
                <li><a href='/streams/mma'>UFC Streams</a> – Fight Night and pay-per-view events</li>
            </ul>

            <h2 className='collection'>Trusted by Millions of Sports Fans</h2>
            <p className='card-description'>
                SportsFeed24 serves over 2 million monthly users seeking reliable <strong>free sports streams</strong>.
                Bookmarksportsfeed24 today and never miss a match again.
            </p>

            <ul className='card-description'>
                <li className='nav-item'>
                    <p className='nav-link'>
                        <span className='collection'>Conclusion</span>
                    </p>
                    <p className='card-description'>
                       Sportsfeed24 is your all-in-one destination for free live sports streaming. From Premier
                        League football and PSL cricket to NFL, NBA, UFC, and F1 — every major event is covered in
                        HD with no interruptions and no cost. Experience sports the way it should be: simple, fast,
                        and completely free onsportsfeed24.
                    </p>
                </li>
            </ul>
        </div>
    );
};
